import getConst from "api/common/getConst";
import { currentUserUrl } from "api/data/users/users";

export { clearAllCaches } from "api/common/caches";

/**
 * Полный URL GET current user — тот же, что пишет Workbox NetworkFirst.
 */
export const getCurrentUserCacheUrl = (): string => getConst("api-url-v2") + currentUserUrl;

/**
 * Удаляет кэш данных текущего пользователя (тот же ключ, что у SW).
 */
export function clearCurrentUserDataCache() {
    if (!isCacheEnabled() || !("caches" in window)) {
        return;
    }
    const requestUrl = getCurrentUserCacheUrl();
    caches.open("currentUserData").then((cache) => {
        cache.delete(requestUrl);
    });
}

/**
 * Кэш SW включён вне development (prod/test/qa).
 */
export function isCacheEnabled() {
    return getConst("env-type") !== "development";
}
